export const common = {
  getUserProfile: async () => {
    try {
      const callbackFun = (window as any).Callback;
      const userData = JSON.parse(callbackFun.getLoggedInUser());
      const { access_token, refresh_token, id_token, client_id, publicKeyBase64, privateKeyBase64} = userData;
      const { publicKey, privateKey } = await importKeyPair(publicKeyBase64, privateKeyBase64);

      return {
        tokens: { token: access_token, refreshToken: refresh_token, idToken: id_token, sigKeyPair: { publicKey, privateKey }},
        clientId: client_id,
      };
    } catch (error) {
      console.info('🚀 ~ getUserProfile: ~ error:', error);
      return {};
    }
  },
  isPWA() {
    try {
      const callbackFun = (window as any).Callback;
      callbackFun.getLoggedInUser();
      return true;
    } catch (error) {
      console.info('🚀 ~ isPWA ~ error:', error);
      return false;
    }
  }
};

async function importKeyPair(publicKeyBase64: string, privateKeyBase64: string): Promise<CryptoKeyPair> {
  const base64ToBytes = (b64: string): Uint8Array =>
    Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));

  const publicKeyBytes = base64ToBytes(publicKeyBase64);
  const privateKeyBytes = base64ToBytes(privateKeyBase64);

  const publicKey = await crypto.subtle.importKey(
    'spki',
    publicKeyBytes.buffer,
    { name: 'ECDSA', namedCurve: 'P-256' },
    true,
    ['verify']
  );

  const privateKey = await crypto.subtle.importKey(
    'pkcs8',
    privateKeyBytes.buffer,
    { name: 'ECDSA', namedCurve: 'P-256' },
    true,
    ['sign']
  );

  return { publicKey, privateKey };
}